<template>
    <div class="trainServices sjzq-index-page">
        <banner></banner>
        <div class="container">
            <!-- 主标题 -->
            <div class="main-title">专业法律服务资源</div>

            <div class="topTabBox">
                <div class="tabTit">
                    <div class="titItem" v-for="(item, titIndex) in onlineTitList" :key="item._id"
                        :class="{ active: item.active }" @click="tabTitClick(titIndex, item._id, 'online')">{{ item.zsmc
                        }}
                    </div>
                </div>

                <div class="tabContent">
                    <div class="contTop">
                        <div class="card-box">
                            <div class="card-title">农产品近期价格指数</div>

                            <div class='titleBox'>
                                <div class='titleWrite' style='text-align: left;'>日期</div>
                                <div class='titleWrite'>指数值</div>
                                <div class='titleWrite'>涨跌值</div>
                                <div class='titleWrite'>涨跌幅</div>
                            </div>
                            <div class='echartsBox'>
                                <div ref="chartContainerline" style="width: 100%; height: 100%;">
                                </div>
                            </div>
                            <div class='conBox' v-for='(item, index) in zhList' :key='index'>
                                <div class='conWrite'>{{ item.date.slice(0, 10) }}</div>
                                <div class='conWrite'>{{ item.sz }}</div>

                                <div class='conWrite' v-if="item.zdValue < 0" style='color: #07B40A;'>{{ item.zdValue }}
                                </div>
                                <div class='conWrite' v-if="!item.zdValue" style='color: #191919;'>-</div>
                                <div class='conWrite' v-if="item.zdValue > 0" style='color: red;'>{{ item.zdValue }}
                                </div>

                                <div class='conWrite' v-if='item.zdScope < 0' style='color: #07B40A;'>{{ item.zdScope
                                    }}%
                                </div>
                                <div class='conWrite' v-if="!item.zdScope" style='color: #191919;'>-</div>
                                <div class='conWrite' v-if='item.zdScope > 0' style='color: red;'>{{ item.zdScope }}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="botTabBox">
                <div class="boxTit">数据报告中心</div>
                <div class="tabTit">
                    <div class="titItem" v-for="(item, titIndex) in offlineTitList" :key="item._id"
                        :class="{ active: item.active }" @click="tabTitClick(titIndex, item._id, 'offline')">{{
                            item.flmc }}
                    </div>
                </div>
                <div class='tabContent'>
                    <div class="contentItem" v-for="(item, index) in offlineContentList" :key="index">
                        <div class="leftBox">
                            <div class='leftBoxcon'>
                                <div class="bigT">{{ item.day }}</div>
                                <div class='bigC'>{{ item.month }}<span style='margin-right:0.1rem'>月</span>{{ item.year
                                }}</div>
                            </div>
                        </div>
                        <div class='rightBox'>
                            <div class="tit">{{ item.bgmc }}</div>
                            <div class="desc">{{ item.bgjj }}</div>
                            <div class="seeBtn" @click="goPage(item.bglj)">立即查看</div>
                        </div>
                    </div>
                </div>

                <div class="paginationBox">
                    <el-pagination background layout="prev, pager, next"
                        @size-change="e => { sizeChange(e, 'offline') }"
                        @current-change="e => { currentChange(e, 'offline') }" :page-size="pageInfo1.pageSize"
                        :total="pageInfo1.count" />
                </div>
            </div>
        </div>

        <div class="btmBox" id="btmBox">
            <div class="boxTit" style=" padding:10px 0 30px">数据产品超市</div>
            <div class='sjcpBox'>
                <div class='carouselWrap'>
                    <!-- 自定义左箭头 -->
                    <div class='customArrow customArrow--left' @click="carouselRef && carouselRef.prev()">
                        <i class='el-icon'><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"/></svg></i>
                    </div>

                    <el-carousel ref="carouselRef" :interval="4000" :arrow="'never'" height='9rem' indicator-position="outside"
                        class='carouselBox' autoplay>
                        <el-carousel-item v-for="(item, index) in shopList" :key="index">
                            <div class='listBox'>
                                <div class='listItem' v-for='(v, k) in item' :key='k'>
                                    <div class='zhoubao'>
                                        <div class='zbName'>{{ v.cpmc }}</div>
                                        <img :src="commenUrl + v.zstp" class='titleImg' alt="" v-if='v.zstp'>
                                    </div>
                                    <div class='itemBottom'>
                                        <div class='nrmk'>
                                            <div class='zbnrbt'>服务内容</div>
                                            <div class='nrWrite'>{{ v.fwnr }}</div>
                                        </div>
                                        <div class='nrmk'>
                                            <div class='zbnrbt'>应用场景</div>
                                            <div class='nrWrite'>{{ v.yycj }}</div>
                                        </div>
                                        <div class='nrmk'>
                                            <div class='zbnrbt'>服务对象</div>
                                            <div class='nrWrite'>{{ v.fwdx }}</div>
                                        </div>
                                        <div class='qwcg' @click=goPage(v.lj)>前往采购</div>
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>

                    <!-- 自定义右箭头 -->
                    <div class='customArrow customArrow--right' @click="carouselRef && carouselRef.next()">
                        <i class='el-icon'><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.624a32 32 0 0 0 0-45.248L382.592 149.376a29.12 29.12 0 0 0-41.728-.064z"/></svg></i>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ref, getCurrentInstance, reactive, nextTick, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import banner from '@/components/bannerMobile.vue'
import * as echarts from 'echarts';

export default {
    name: "trainServices",
    props: {
        themeColor: {
            type: String,
            default: 'blue'
        },
    },

    components: { banner },

    setup() {
        onMounted(() => {
            getOnlineTypeList()
            getsjcpShop()
        })

        const { proxy } = getCurrentInstance();
        const chartContainerline = ref(null);
        const carouselRef = ref(null);
        let myChart = null;
        const router = useRouter();
        const route = useRoute()
        const yData = ref([])
        const xData = ref([])

        const pageInfo = ref({
            pageSize: 8,
            pageNo: 1,
            count: 0
        })
        const pageInfo1 = ref({
            pageSize: 6,
            pageNo: 1,
            count: 0
        })



        // 卓创数据指数nav
        const onlineTitList = ref([])
        const getOnlineTypeList = () => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_ZCINDEXTYPE',
                method: "post",
                data: {}
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    onlineTitList.value = res.data.result
                    nextTick(() => {
                        if (onlineTitList.value.length > 0) {
                            onlineTitList.value[0].active = true
                            getechartsData(onlineTitList.value[0]._id)
                            getzhList(onlineTitList.value[0]._id)
                        }
                    })

                }
            }).catch((err) => {
                console.log(err);
            })
        }

        //农产品获取近期价格指数
        const zhList = ref([])
        const getzhList = (id) => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_NEARPRICEINDEX',
                method: "post",
                data: {
                    "zs": id
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    zhList.value = res.data.result.list
                    // zhList.value.map((item,index) =>{
                    //     item.zdScope = (item.zdScope * 100)/100
                    // })

                }
            }).catch((err) => {
                console.log(err);
            })
        }

        //获取echarts列表
        const getechartsData = (id) => {
            xData.value = []
            yData.value = []
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_LINEGRAPH',
                method: "post",
                data: {
                    "zs": id
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    res.data.result.map((item, index) => {
                        xData.value.push(item.rq.slice(0, 10))
                        yData.value.push(item.sz)
                    }
                    )
                }
                echartsInit()
            }).catch((err) => {
                console.log(err);
            })
        }


        function echartsInit() {
            if (chartContainerline.value) {
                myChart = echarts.init(chartContainerline.value);
                const option = {
                    backgroundColor: "#fff",

                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            lineStyle: {
                                color: "#57617B",
                            },
                        },
                    },

                    grid: {
                        top: '5%',
                        left: "1%",
                        right: "8%",
                        bottom: "0%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            boundaryGap: false,
                            axisLine: {
                                lineStyle: {
                                    color: "#A5AAB5",
                                },
                            },
                            axisLabel: {
                                margin: 10,
                                textStyle: {
                                    fontSize: 10,
                                    color: '#A5AAB5'
                                },
                            },
                            axisTick: {
                                show: false
                            },
                            data: xData.value
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            axisTick: {
                                show: false,
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "#A5AAB5",
                                },
                            },
                            axisLabel: {
                                margin: 10,
                                textStyle: {
                                    fontSize: 14,
                                    color: '#A5AAB5'
                                },
                            },
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#57617B",
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "指数值",
                            type: "line",
                            smooth: true,
                            lineStyle: {
                                normal: {
                                    width: 2,
                                },
                            },

                            itemStyle: {
                                normal: {
                                    color: "#1663FF",
                                },
                            },
                            data: yData.value,
                        },

                    ],
                };
                myChart.setOption(option);
                // 监听窗口大小变化，自适应图表
                window.addEventListener('resize', () => {
                    myChart.resize();
                });
            }
        }









        //类型切换
        const currentOnlineId = ref('')
        const currentOfflineId = ref('')
        const tabTitClick = (titIndex, id, type) => {
            if (type == 'online') {
                // 卓创数据指数
                currentOnlineId.value = id;
                onlineTitList.value.forEach((item, index) => {
                    item.active = index == titIndex ? true : false
                })
                pageInfo.value.pageNo = 1
                getechartsData(currentOnlineId.value)
                getzhList(currentOnlineId.value)

            } else {
                // 数据报告中心的处理
                currentOfflineId.value = id;
                offlineTitList.value.forEach((item, index) => {
                    item.active = index == titIndex ? true : false
                })
                pageInfo1.value.pageNo = 1
                getOfflineContentList(currentOfflineId.value)
            }
        }

        //分页事件
        const sizeChange = (e, type) => {

            if (pageInfo1.value.pageSize == e) return;
            pageInfo1.value.pageSize = e;
            getOfflineContentList(currentOfflineId.value)


        };
        const currentChange = (e, type) => {

            if (pageInfo1.value.pageNo == e) return;
            pageInfo1.value.pageNo = e;
            getOfflineContentList(currentOfflineId.value)

        };






        // 数据报告中心nav
        const offlineTitList = ref([])
        const getOfflineTypeList = () => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_BGZXTYPE',
                method: "post",
                data: {}
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    offlineTitList.value = res.data.result
                    console.log(offlineTitList.value, 99999)
                    nextTick(() => {
                        if (offlineTitList.value.length > 0) {
                            offlineTitList.value[0].active = true
                            getOfflineContentList(offlineTitList.value[0]._id)
                        }
                    })
                }
            }).catch((err) => {
                console.log(err);
            })
        }
        getOfflineTypeList()


        //数据报告中心列表
        const offlineContentList = ref([])
        const getOfflineContentList = (id) => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_BGFINDPAGE',
                method: "post",
                data: {
                    "fl": id,
                    "pageInfo": pageInfo1.value
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    offlineContentList.value = res.data.result.list.map(item => {
                        // const date = new Date(item.fbrq);
                        // item.day = date.getDate()
                        // item.month = (date.getMonth() + 1).toString().padStart(2, '0')
                        // item.year = date.getFullYear()
                        if (item.fbrq) {
                            item.day = item.fbrq.slice(8, 10)
                            item.month = item.fbrq.slice(5, 7)
                            item.year = item.fbrq.slice(0, 4)
                        }


                        return item
                    })
                    pageInfo1.value.pageNo = res.data.result.pageNo
                    pageInfo1.value.pageSize = res.data.result.pageSize
                    pageInfo1.value.count = res.data.result.count
                }
            }).catch((err) => {
                console.log(err);
            })
        }
        //获取数据产品超市列表
        const shopList = ref([])
        const getsjcpShop = () => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_SHOPFINDPAGE',
                method: "post",
                data: {
                    pageInfo: {
                        "pageSize": "50",
                        "pageNo": "1"
                    }
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    shopList.value = groupArray(res.data.result.list, 1)
                    console.log(shopList.value, 898989898)


                }
            }).catch((err) => {
                console.log(err);
            })
        }

        const groupArray = (arr, size) => {//轮播图数组转换
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        }
        //页面跳转
        const goPage = (url) => {
            window.open(url);
        };
        return {
            onlineTitList,
            tabTitClick,
            currentOnlineId,
            currentOfflineId,
            pageInfo,
            pageInfo1,
            sizeChange,
            currentChange,
            offlineTitList,
            offlineContentList,
            goPage,
            groupArray,
            xData,
            yData,
            getzhList,
            zhList,
            getechartsData,
            shopList,
            getsjcpShop,
            echartsInit,
            chartContainerline,
            carouselRef
        }
    }
}
</script>
<style lang="less">
// ==========================================
// H5 移动端样式 - 卓创数据专区
// 设计图：100px = 1rem
// ==========================================

// 唯一命名空间，防止样式泄露
.sjzq-index-page {
    // 通用文本样式
    .text-base {
        font-size: 0.28rem;
        color: #191919;
        line-height: 1.4;
    }

    // 主容器
    .container {
        padding: 0 0.32rem;

        // 主标题
        .main-title {
            font-size: 0.36rem;
            font-weight: 600;
            color: #1A1A1A;
            text-align: center;
            padding: 0.4rem 0;
        }

        // Tab 切换
        .tabTit {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 0.3rem;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }

            .titItem {
                flex-shrink: 0;
                font-size: 0.28rem;
                font-weight: 100;
                color: #1A1A1A;
                padding: 0.2rem 0.3rem;
                position: relative;
                cursor: pointer;
                font-weight: 400;

                &.active {
                    color: #1A1A1A;
                    font-weight: 600;

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 0.48rem;
                        height: 0.05rem;
                        background: #191919;
                    }
                }
            }
        }

        // 卓创数据指数区域
        .topTabBox {
            .tabContent {
                background: #fff;
                border-radius: 0.2rem;
                padding: 0.3rem;

                .contTop {
                    .card-box {
                        .card-title {
                            font-size: 0.3rem;
                            font-weight: 600;
                            color: #191919;
                            margin-bottom: 0.2rem;
                        }

                        .echartsBox {
                            width: 100%;
                            height: 4.2rem;
                            margin: 0.2rem 0;
                        }

                        .titleBox {
                            display: flex;
                            background: #F0F5FF;
                            border-radius: 0.1rem;
                            padding: 0.2rem 0.15rem;

                            .titleWrite {
                                flex: 1;
                                text-align: center;
                                font-size: 0.24rem;
                                color: #191919;
                                font-weight: 600;
                            }
                        }

                        .conBox {
                            display: flex;
                            padding: 0.24rem 0.15rem;
                            border-bottom: 1px solid #F0F5FF;

                            .conWrite {
                                flex: 1;
                                text-align: center;
                                font-size: 0.24rem;
                                color: #191919;
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }

        // 数据报告中心
        .botTabBox {
            width: 100%;
            min-height: 4rem;
            padding: 0 0rem 0.4rem;
            display: flex;
            flex-direction: column;

            .boxTit {
                font-size: 0.36rem;
                font-weight: 600;
                color: #1A1A1A;
                text-align: center;
                padding: 0.4rem 0;
            }

            .tabTit {
                display: flex;
                justify-content: flex-start;
                margin-bottom: 0.3rem;
                overflow-x: auto;
                -webkit-overflow-scrolling: touch;
                scrollbar-width: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                .titItem {
                    flex-shrink: 0;
                    font-size: 0.28rem;
                    font-weight: 100;
                    color: #191919;
                    padding: 0.2rem 0.3rem;
                    position: relative;
                    cursor: pointer;
                    font-weight: 400;

                    &.active {
                        color: #191919;
                        font-weight: 600;

                        &::after {
                            content: '';
                            position: absolute;
                            bottom: 0;
                            left: 50%;
                            transform: translateX(-50%);
                            width: 0.48rem;
                            height: 0.05rem;
                            background: #191919;
                        }
                    }
                }
            }

            .tabContent {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 0.2rem;

                .contentItem {
                    background: rgba(255, 255, 255, 0.95);
                    border-radius: 0.2rem;
                    padding: 0.3rem;
                    display: flex;
                    width: 100%;
                    box-sizing: border-box;

                    .leftBox {
                        width: 1.4rem;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;

                        .leftBoxcon {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;
                            align-items: center;
                        }

                        .bigT {
                            width: 0.42rem;
                            height: 0.46rem;
                            font-family: DIN, DIN;
                            font-weight: 900;
                            font-size: 0.36rem;
                            color: #191919;
                            line-height: 0.46rem;
                            text-align: center;
                            font-style: normal;
                        }

                        .bigC {
                            height: 0.28rem;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            font-size: 0.2rem;
                            color: #595959;
                            line-height: 0.2rem;
                            text-align: left;
                            font-style: normal;
                            margin-top: 0.1rem;
                        }
                    }

                    .rightBox {
                        width: 5rem;
                        margin-left: 0.2rem;

                        .tit {
                            width: 5.3rem;
                            font-size: 0.32rem;
                            font-weight: 900;
                            color: #191919;
                            margin-bottom: 0.1rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            margin-bottom: 0.2rem;
                        }

                        .desc {
                            width: 5rem;
                            font-size: 0.24rem;
                            color: #5c5c5c;
                            line-height: 0.4rem;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }

                        .seeBtn {
                            width: 1.64rem;
                            height: 0.53rem;
                            border-radius: 0.34rem;
                            border: 1px solid #191919;
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            margin-top: 0.24rem;
                        }
                    }
                }
            }

            .paginationBox {
                margin-top: 0.3rem;
                display: flex;
                justify-content: center;

                .el-pager li {
                    width: 0.52rem !important;
                    height: 0.52rem !important;
                    min-width: 0.52rem !important;
                    line-height: 0.52rem !important;
                    font-size: 0.24rem !important;
                    border-radius: 0 !important;
                    background: #fff !important;
                    border: 1px solid #dcdfe6 !important;
                    color: #606266 !important;
                    margin: 0 2px !important;
                }

                .el-pager li.is-active {
                    background: #1663FF !important;
                    color: #fff !important;
                    border-color: #1663FF !important;
                }

                .btn-next,
                .btn-prev {
                    border: none !important;
                    background: transparent !important;
                }
            }
        }
    }

    // 数据产品超市
    .btmBox {
        padding: 0 0.32rem;

        .boxTit {
            font-size: 0.36rem;
            font-weight: 600;
            color: #191919;
            text-align: center;
            padding: 0.6rem 0 0.3rem;
        }

        .sjcpBox {
            width: 100%;

            .carouselWrap {
                position: relative;

                .customArrow {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 0.6rem;
                    height: 0.6rem;
                    border-radius: 50%;
                    background: rgba(0, 0, 0, 0.2);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    z-index: 10;

                    .el-icon {
                        width: 0.32rem;
                        height: 0.32rem;
                        color: #fff;

                        svg {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    &:active {
                        background: rgba(0, 0, 0, 0.4);
                    }

                    &.customArrow--left {
                        left: -10px;
                    }

                    &.customArrow--right {
                        right: -10px;
                    }
                }

                .carouselBox {
                    width: 100%;
                }

                .el-carousel__indicators--outside {
                    button {
                        width: 0.6rem;
                        height: 0.08rem;
                        border-radius: 0.04rem;
                        background: #D8D8D8;
                    }

                    .el-carousel__indicator.is-active button {
                        background: #000;
                    }
                }

                .el-carousel__item {
                    height: auto;
                }
            }

            .listBox {
                width: 100%;
                height: 9rem;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
                gap: 0.15rem;

                .listItem {
                    width: 100%;
                    background: #fff;
                    border-radius: 0.2rem;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;

                    .zhoubao {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.15rem;
                        background: #E8F0FF;
                        height: 1.2rem;

                        .zbName {
                            flex: 1;
                            font-size: 0.36rem;
                            font-weight: 600;
                            color: #121C30;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .titleImg {
                            margin-left: 0.2rem;
                            width: 0.6rem;
                            height: 0.6rem;
                            object-fit: contain;
                        }
                    }

                    .itemBottom {
                        flex: 1;
                        padding: 0.15rem;
                        display: flex;
                        flex-direction: column;

                        .nrmk {
                            border-bottom: 1px solid #EBEBEB;
                            padding: 0.4rem 0 0.28rem;
                            height: 2.2rem;
                            box-sizing: border-box;

                            .zbnrbt {
                                font-size: 0.28rem;
                                color: #747C8D;
                                margin-top: 0.12rem;
                            }

                            .nrWrite {
                                font-size: 0.28rem;
                                font-weight: 600;
                                color: #676D7A;
                                line-height: 0.53rem;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                margin-top: 0.2rem;
                            }
                        }

                        .qwcg {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 0.53rem;
                            border-radius: 0.25rem;
                            border: 1px solid #191919;
                            font-size: 0.24rem;
                            color: #191919;
                            cursor: pointer;
                            background: transparent;
                            width: 2.28rem;
                            margin: 0.4rem auto 0;
                        }
                    }
                }
            }
        }
    }
}

// 页面根元素基础样式（独立于命名空间）
.trainServices.sjzq-index-page {
    width: 100%;
    background: #F7F7F7;
    padding-top: 1rem;
    box-sizing: border-box;
}
</style>
